import React, { useState } from "react";

const questions = [
  {
    id: 1,
    text: "1. Trong DiSC, người hay xài icon cười ẻ rụng rốn, nói nhiều, hướng ngoại thuộc nhóm nào?",
    options: {
      A: "Nhóm D (Dominance)",
      B: "Nhóm i (Influence)",
      C: "Nhóm C (Conscientiousness)"
    },
    correct: "B"
  },
  {
    id: 2,
    text: "2. Gặp ông sếp nhóm D (Driver), cách chốt báo cáo chuẩn nhất là gì?",
    options: {
      A: "Gửi 1 email dài 3 trang giải thích nỗi khổ của team.",
      B: "Vô thẳng vấn đề: 'Sếp ơi, xong rồi, số liệu tăng 20%. Hết.'",
      C: "Rủ sếp đi uống bia rồi mới rào trước đón sau báo cáo."
    },
    correct: "B"
  },
  {
    id: 3,
    text: "3. Đồng nghiệp nhóm S (Supporter) cực kỳ sợ điều gì nhất?",
    options: {
      A: "Phải nói chuyện trước đám đông.",
      B: "Bị giao việc gấp, thay đổi kế hoạch cái đùng mà không báo trước.",
      C: "Bị sếp bắt làm file Excel."
    },
    correct: "B"
  },
  {
    id: 4,
    text: "4. Làm sao để thuyết phục một 'Thánh soi' nhóm C (Checker) đồng ý ý tưởng của bạn?",
    options: {
      A: "Đưa ra bằng chứng, số liệu cụ thể và quy trình rõ ràng.",
      B: "Dùng lời đường mật, khen ngợi họ hết lời.",
      C: "Thúc giục họ phải quyết định ngay lập tức trong 5 phút."
    },
    correct: "A"
  },
  {
    id: 5,
    text: "5. 'Sếp nhóm C' ở Hà Nội và 'Sếp nhóm C' ở TP.HCM khác nhau chỗ nào?",
    options: {
      A: "Sếp Bắc thích đi nhậu, sếp Nam thích cafe.",
      B: "Sếp Bắc thường thiên về tính trang trọng, cần đóng dấu nhiều cấp. Sếp Nam vẫn cần data nhưng linh hoạt lách luật nhanh hơn.",
      C: "Sếp Nam không cần nhìn data, chỉ cần vui là duyệt."
    },
    correct: "B"
  },
  {
    id: 6,
    text: "6. Mở Group Zalo công việc thấy sếp chat mỗi câu 'Xong chưa?'. Bạn hiểu là:",
    options: {
      A: "Sếp đang giận dữ tột độ.",
      B: "Đó chỉ là cách giao tiếp ngắn gọn điển hình của sếp nhóm D.",
      C: "Sếp bị hack nick."
    },
    correct: "B"
  },
  {
    id: 7,
    text: "7. Khi làm việc với đối tác miền Nam mang đậm chất thực dụng (Pragmatic), người nhóm C ở miền Bắc nên chú ý điều gì?",
    options: {
      A: "Cần linh hoạt đẩy nhanh tốc độ, bớt cầu kỳ quy trình rườm rà nếu không cần thiết.",
      B: "Bắt họ phải viết email dạ vâng đầy đủ mới làm việc.",
      C: "Cố tình làm chậm lại để họ phải chờ."
    },
    correct: "A"
  },
  {
    id: 8,
    text: "8. Sự kết hợp nào sau đây dễ 'choảng' nhau nhất trong văn phòng nếu không hiểu ý?",
    options: {
      A: "Người nhóm D (thích nhanh) và người nhóm C (thích chi tiết, rà soát lâu).",
      B: "Người nhóm i (thích vui) và người nhóm S (thích hòa bình).",
      C: "Hai người nhóm S làm việc chung."
    },
    correct: "A"
  },
  {
    id: 9,
    text: "9. Châm ngôn sống của nhóm i (Inspirer) là gì?",
    options: {
      A: "Làm đúng làm chuẩn.",
      B: "Làm là phải có anh em cùng vui.",
      C: "Nhanh gọn lẹ."
    },
    correct: "B"
  },
  {
    id: 10,
    text: "10. Sếp D ở Hà Nội thường thể hiện quyền lực thông qua hệ thống phân cấp bậc rõ ràng, còn Sếp D ở Sài Gòn thì sao?",
    options: {
      A: "Cũng y chang vậy.",
      B: "Thường hay bỏ qua cấp bậc, chỉ cần nhảy vào xử lý cho xong việc là được.",
      C: "Sợ nhân viên đánh giá nên không dám thể hiện quyền lực."
    },
    correct: "B"
  },
  {
    id: 11,
    text: "11. Sai lầm chí mạng khi bạn là sếp và muốn động viên nhân viên nhóm C (Checker)?",
    options: {
      A: "Thưởng cho họ một cục tiền mập mạp.",
      B: "Kéo họ lên sân khấu trước mặt 500 người vỗ tay tung hô om sòm.",
      C: "Gửi thư khen ngợi phân tích rõ họ làm tốt ở điểm nào."
    },
    correct: "B"
  },
  {
    id: 12,
    text: "12. Công cụ DiSC theo chuẩn của công ty mình tuyệt đối KHÔNG được dùng để làm gì?",
    options: {
      A: "Dùng để phân tích cách giao tiếp nhóm.",
      B: "Dùng để đánh giá ai thông minh hơn ai, hoặc dùng để đuổi việc/tuyển dụng.",
      C: "Dùng để hiểu lý do tại sao Zalo team hay bị cãi vã."
    },
    correct: "B"
  }
];

export default function DiSCKnowledge() {
  const [answers, setAnswers] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [score, setScore] = useState(0);

  const handleSelect = (questionId, optionKey) => {
    if (!isSubmitted) {
      setAnswers({ ...answers, [questionId]: optionKey });
    }
  };

  const calculateScore = () => {
    if (Object.keys(answers).length < questions.length) {
      alert("Bạn ơi, làm nốt mấy câu còn thiếu để xem mình đạt mấy điểm nhé!");
      return;
    }

    let currentScore = 0;
    questions.forEach((q) => {
      if (answers[q.id] === q.correct) {
        currentScore++;
      }
    });

    setScore(currentScore);
    setIsSubmitted(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px", fontFamily: "sans-serif" }}>
      <h1 style={{ textAlign: "center", color: "#333" }}>Kiểm Tra 'Độ Đắc Nhân Tâm' (DiSC) 🧠</h1>
      
      {!isSubmitted ? (
        <p style={{ textAlign: "center", color: "#666", marginBottom: "30px" }}>
          Làm sương sương 12 câu trắc nghiệm này để xem bạn đã thấu hiểu nỗi lòng anh em đồng nghiệp chưa nhé!
        </p>
      ) : (
        <div style={{ textAlign: "center", padding: "20px", borderRadius: "8px", backgroundColor: score >= 9 ? "#d4edda" : "#fff3cd", color: score >= 9 ? "#155724" : "#856404", marginBottom: "30px", border: `2px solid ${score >= 9 ? "#c3e6cb" : "#ffeeba"}` }}>
          <h2>Điểm của bạn: {score} / 12</h2>
          <p style={{ fontSize: "18px", fontWeight: "bold" }}>
            {score === 12 ? "Thủ khoa ngành Tâm lý học hành vi! 🏆" :
             score >= 8 ? "Khá lắm! Sống sót qua các mùa drama công sở tốt! 🔥" :
             "Kém tinh tế quá nha! Đi đọc lại tài liệu DiSC khẩn trương! 😅"}
          </p>
          <p style={{ fontSize: "14px" }}>Kéo xuống dưới để xem mình sai ở đâu nhé 👇</p>
        </div>
      )}

      <div>
        {questions.map((q) => (
          <div key={q.id} style={{ marginBottom: "25px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
            <p style={{ fontWeight: "bold", marginTop: "0" }}>{q.text}</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {Object.entries(q.options).map(([key, text]) => {
                let labelStyle = { cursor: isSubmitted ? "default" : "pointer", display: "flex", alignItems: "center", gap: "10px", padding: "8px", borderRadius: "5px" };
                
                if (isSubmitted) {
                  if (key === q.correct) {
                    labelStyle.backgroundColor = "#d4edda";
                    labelStyle.border = "1px solid #c3e6cb";
                  } else if (answers[q.id] === key && key !== q.correct) {
                    labelStyle.backgroundColor = "#f8d7da";
                    labelStyle.border = "1px solid #f5c6cb";
                  }
                }

                return (
                  <label key={key} style={labelStyle}>
                    <input
                      type="radio"
                      name={`knowledge-${q.id}`}
                      value={key}
                      checked={answers[q.id] === key}
                      onChange={() => handleSelect(q.id, key)}
                      disabled={isSubmitted}
                      style={{ width: "20px", height: "20px" }}
                    />
                    {text}
                  </label>
                );
              })}
            </div>
            {isSubmitted && answers[q.id] !== q.correct && (
              <p style={{ color: "#d9534f", fontSize: "14px", marginTop: "10px", fontWeight: "bold" }}>
                👉 Đáp án đúng là {q.correct} nha bạn ơi!
              </p>
            )}
          </div>
        ))}

        {!isSubmitted ? (
          <button 
            onClick={calculateScore} 
            style={{ width: "100%", padding: "15px", fontSize: "18px", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}
          >
            Nộp Bài Chấm Điểm!
          </button>
        ) : (
          <button 
            onClick={() => { setIsSubmitted(false); setAnswers({}); setScore(0); window.scrollTo({ top: 0, behavior: "smooth" }); }} 
            style={{ width: "100%", padding: "15px", fontSize: "18px", backgroundColor: "#333", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}
          >
            Làm Lại Lần Nữa Cho Nhớ!
          </button>
        )}
      </div>
    </div>
  );
}